module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SendMessage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', [_c('div', {
    staticClass: "md-form"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "md-textarea",
    attrs: {
      "type": "text",
      "id": "csp-message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "csp-message"
    }
  }, [_vm._v("Message")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('p', {
    staticClass: "card-text csp-banner-text csp-margin-top"
  }, [_vm._v("\n      If you have any questions or need to change any information, \n      please send us a message using the form below. Thank you!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34a8bb68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/panels/SendMessage.vue
// module id = 855
// module chunks = 2